import type { DealsRangesConfig } from '@/helpers/featureFlags'

const getTypicalSellingPriceAnalyticsData = (
  listing: {
    typicalSellingPrice?: number | null
    deal?: string | null
    seller: {
      storefront?: {
        name: string
      } | null
    }
  },
  enableSellingPriceCalculation: boolean,
  enableSellingPriceCalculationCostco: boolean,
  dealsRangesConfig?: DealsRangesConfig
) => {
  const isCostcoListing =
    listing.seller.storefront?.name.toLowerCase().includes('costco') ?? false

  const typicalSellingPrice = listing.typicalSellingPrice

  // Determine which deal ranges represent > 20% discount
  // A range has > 20% discount if min < -0.2 or max < -0.2
  const significantDiscountRanges: string[] = []
  if (dealsRangesConfig) {
    const ranges = [
      dealsRangesConfig.rangeOne,
      dealsRangesConfig.rangeTwo,
      dealsRangesConfig.rangeThree,
    ]

    ranges.forEach((range) => {
      if (!range?.name) return

      const hasSignificantDiscount =
        (range.min !== undefined && range.min < -0.2) ||
        (range.max !== undefined && range.max < -0.2)

      if (hasSignificantDiscount) {
        significantDiscountRanges.push(range.name)
      }
    })
  }

  const hasSignificantDiscount =
    listing.deal != null && significantDiscountRanges.includes(listing.deal)

  const isTypicalSellingPriceShown =
    enableSellingPriceCalculation &&
    (!isCostcoListing || enableSellingPriceCalculationCostco) &&
    typicalSellingPrice != null &&
    hasSignificantDiscount

  return {
    typical_selling_price: typicalSellingPrice ?? undefined,
    is_typical_selling_price_shown: isTypicalSellingPriceShown,
  }
}

export default getTypicalSellingPriceAnalyticsData
